module.exports = __webpack_public_path__ + "img/DATSUN.e457faf.jpg";